import { Suspense, useState } from 'react'
import {
    Await,
    defer,
    Link,
    useSearchParams,
    useNavigate,
    useLoaderData,
    json
} from 'react-router-dom'
import { pantheon } from '../util/api'
import LoadingSpinner from './components/LoadingSpinner'
import Heading from './helper/Heading'
import { Title } from './helper/DocumentTitle'
import styles from '../styles/module/Pantheon.module.scss'

import { useEffect } from 'react'

export const loader = async () => {
    return defer({ pantheon: pantheon() })
}

export default function Pantheon() {
    const pageName = 'زیارتگاه'
    Title(pageName)

    const [loaderData, setLoaderData] = useState(useLoaderData())

    const [error, setError] = useState()
    const [data, setData] = useState()
    const [isLoading, setIsLoading] = useState(true)
    const [showPopup, setShowPopup] = useState(false)

    let [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate()

    useEffect(() => {
        document.querySelector('header span').innerText = pageName
    }, [])

    return (
        <section className={styles.pantheon}>
              <Link to={`../`} className='btn btn-back-top'>بازگشت</Link>
            <div className='__frame' data-width={`large`}>
                <div className={styles.emam}>

                    <figure>
                        <img src={require('../../src/images/emam-khomenie.png')} />
                    </figure>

                    <figure>
                        <img src={require('../../src/images/slogan.png')} />
                    </figure>

                    <figure>
                        <img src={require('../../src/images/emam-khamenie.png')} />
                    </figure>
                </div>
                <div className='grid grid--fit grid--gap-1' style={{ '--data-width': '250px', 'width': '100%' }}>
                    <Suspense fallback={<LoadingSpinner />}>
                        <Await
                            resolve={loaderData.pantheon}
                            errorElement={<p>⚠️</p>}>
                            {(data) => {
                                console.log(data)
                                return (
                                    <>
                                        {
                                            data.map((item) => {
                                                return <div className={styles.item}>
                                                    <div className={`${styles.itemBody} d-flex align-items-center justify-content-between`} style={{ columnGap: '1rem' }}>
                                                        {item.title}&nbsp;
                                                        <a target={'_blank'} href={`https://www.google.com/maps/dir//${JSON.parse(item.area)[0]},${JSON.parse(item.area)[1]}/@${JSON.parse(item.area)[0]},48.3079047,14z`}>
                                                            <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M9.11688 13L3.90422 11.1398L0.780844 12.3799C0.597943 12.4655 0.422078 12.4548 0.253246 12.3479C0.0844153 12.241 0 12.0806 0 11.8668V1.88158C0 1.73903 0.0316556 1.60718 0.0949673 1.48602C0.158279 1.36486 0.253247 1.28289 0.37987 1.24013L3.90422 0L9.11688 1.83882L12.2192 0.620066C12.4021 0.534539 12.5779 0.534539 12.7468 0.620066C12.9156 0.705592 13 0.848136 13 1.0477V11.2467C13 11.3893 12.9578 11.514 12.8734 11.6209C12.789 11.7278 12.6834 11.8026 12.5568 11.8454L9.11688 13ZM8.84253 12.4227V2.18092L4.15747 0.534539V10.7763L8.84253 12.4227Z" fill="url(#paint0_linear_642_1438)" />
                                                                <defs>
                                                                    <linearGradient id="paint0_linear_642_1438" x1="6.5" y1="0" x2="6.5" y2="13" gradientUnits="userSpaceOnUse">
                                                                        <stop stop-color="#F8312F" />
                                                                        <stop offset="1" stop-color="#BB1D80" />
                                                                    </linearGradient>
                                                                </defs>
                                                            </svg>
                                                            مسیریابی
                                                        </a>
                                                    </div>
                                                </div>
                                            })
                                        }
                                    </>
                                )

                            }}
                        </Await>
                    </Suspense>
                </div>
            </div>
            <Link to={`../`} className='btn btn-back-bottom'>بازگشت</Link>
        </section>
    )
}